<template>
<v-container>
  <v-row>
    <v-col>
      <p class="text-h5 mb-3">Export guide</p>
      <p class="text-body-1">Our company has the ability to send the vehicle to any point of the globe! The port of Busan in Korea is recognized as one of the largest transportation hubs in the world. Thus logistics from Korea can be anywhere in the world!</p>
    </v-col>
  </v-row>
  <v-row>
    <v-col v-if="$vuetify.display.mdAndUp">
      <v-timeline align="start">
        <v-timeline-item
            v-for="(item, i) in items"
            :key="i"
            :dot-color="item.color"
            :icon="item.icon"
            fill-dot
        >
          <v-card>
            <v-card-title :class="['text-h6', `bg-${item.color}`]">
              {{ item.title }}
            </v-card-title>
            <v-card-text class="bg-white text--primary">
              <p>{{ item.description }}</p>
              <v-btn
                  v-if="item.buttonVisible"
                  :color="item.color"
                  variant="outlined"
                  @click="item.callback()"
              >
                {{ item.buttonTitle }}
              </v-btn>
            </v-card-text>
          </v-card>
        </v-timeline-item>
      </v-timeline>
    </v-col>
    <v-col v-if="$vuetify.display.smAndDown">
      <v-row
          v-for="(item, i) in items"
          :key="i"
          class="mx-1 mb-1"
      >
        <p class="text-h6">{{ i + 1 + '. ' + item.title }}</p>
        <p class="text-body">{{ item.description }}</p>
      </v-row>
    </v-col>
  </v-row>
</v-container>
</template>

<script>

import {router} from "@/router";

export default {
  name: "ExportGuideView",
  data: () => ({
    items: [
      {
        color: 'green-lighten-1',
        icon: 'mdi-search-web',
        title: 'Search car',
        description: 'How to buy cars from Korea, Russia and Japan?\nTo begin, select the country from which you want to buy a car. In these countries, there are so many cars from different manufacturers and brands both new and used.\nFind a car that suits your needs with the help of our service. You can use the filter.',
        buttonVisible: true,
        buttonTitle: 'Search',
        callback: () => {
          router.push({name: 'home'})
        }
      },
      {
        color: 'green-lighten-1',
        icon: 'mdi-car-multiple',
        title: 'Send request',
        description: 'Here you can find detailed information about the car. Note to the price - this is the price FOB. If you liked this car, you can send a request to the company manager. In the feedback form you can ask all the questions that interest you.',
        buttonVisible: true,
        buttonTitle: 'Orders',
        callback: () => {
          router.push({name: 'profile', hash: '#orders'})
        }
      },
      {
        color: 'green-lighten-1',
        icon: 'mdi-forum-outline',
        title: 'Ask manager',
        description: 'At this stage, the company\'s manager will answer all your questions. Manager will calculate the cost of car delivery to your place.',
        buttonVisible: true,
        buttonTitle: 'About',
        callback: () => {
          router.push({name: 'about'})
        }
      },
      {
        color: 'green-lighten-1',
        icon: 'mdi-handshake-outline',
        title: 'Client resolution',
        description: 'Then you make the decision.\nIf you like the car, its condition and the price, then we move on to the next step'
      },
      {
        color: 'indigo-lighten-2',
        icon: 'mdi-camera',
        title: 'Photo description (paid only)',
        description: 'If you are interested in buying this car, you can ask the manager to make detailed pictures of the car.\nThe manager will describe in detail the entire vehicle and provides the data in a convenient form. He make more than 30 photos of car, test the thickness of paint by special device, and check the technical condition.'
      },
      {
        color: 'red-lighten-1',
        icon: 'mdi-file-document-edit',
        title: 'Contract',
        description: 'Now when you have chosen the necessary car you need to sign a contract for its purchase.'
      },
      {
        color: 'red-lighten-1',
        icon: 'mdi-account-cash',
        title: 'Invoice',
        description: 'In this step, you should pay the cost of the car. Please note that the car dealer will get his money only after when the vehicle is ready to be sent to you. In this way, our company ensures you the delivery of cars to your place. Otherwise, your money will be returned to you.'
      },
      {
        color: 'blue-lighten-1',
        icon: 'mdi-ferry',
        title: 'Delivery',
        description: 'Our company has the ability to send the vehicle to any point of the globe! The port of Busan in Korea is recognized as one of the largest transportation hubs in the world. Thus logistics from Korea can be anywhere in the world!'
      },
      {
        color: 'purple-lighten-2',
        icon: 'mdi-account-box',
        title: 'Selfie',
        description: 'Finally, we are waiting for your selfie for our gallery. Your smile is very valuable to us!'
      },
    ],
  }),
}
</script>

<style scoped>

</style>